// @todo @sentry/browser install
// @see resource/view/common/tags/sentry/twig
//import * as Sentry from '@sentry/broser';

// export const errorTracker = { /* TODO sentry/browser initialization */};

export const integration = {
  /**
   * @var Sentry|null
   */
  tracker: null,

  /**
   * @param Vue
   */

  /**
   * @param message
   * @param level
   * @param vm
   * @param trace
   */
  report(message, vm, level = 'error', trace = '') {
    if (!this.tracker) {
      return;
    }
    const componentName = this._formatComponentName(vm);
    this.tracker.withScope((scope) => {
      scope.setLevel(level);
      scope.setExtra('componentName', componentName);
      scope.setExtra('trace', trace);
      this.tracker.captureException(new Error(`[Vue ${level}]: ${message}`));
    });
  },

  /**
   * レポート用のコンポーネント名を取得
   * @see @sentry/integrations/esm/vue.js
   *
   * @param vm
   * @return {string}
   * @private
   */
  _formatComponentName(vm) {
    if (!vm) {
      return 'anonymous';
    }
    if (vm.$root === vm) {
      return 'root instance';
    }
    const name = vm._isVue ?
      vm.$options.name || vm.$options._componentTag :
      vm.name;
    return ((name ? 'component <' + name + '>' : 'anonymous component') +
    (vm._isVue && vm.$options.__file ? ' at ' + vm.$options.__file : ''));
  },
};
